<template>
  <v-card
    no-gutter
    style="
      width: 100% !important;
      box-sizing: border-box;
      display: flex;
      flex-flow: column;
      overflow: hidden;
      height: 100%;
      max-height: 100%;
    "
    class="align-center justify-center text-center"
  >
    <v-card-title
      style="height: 30px"
      class="headline mb-0 py-1 justify-center text-center align-self-center"
      >{{ module.title }}</v-card-title
    >
    <v-dialog v-model="addDialog" max-width="500px">
      <v-card>
        <v-card-title>
          {{ $t("imageMap.chooseTag") }}
        </v-card-title>
        <v-card-text>
          <v-autocomplete
            autocomplete="off"
            :loading="status.loading"
            :label="$t('alarm.fields.tag')"
            v-model="deveui"
            :items="tags"
            item-text="name"
            item-value="deveui"
            prepend-icon="mdi-cellphone-link"
            clearable
          ></v-autocomplete>
        </v-card-text>

        <v-card-actions>
          <v-btn color="primary" text @click="submitDialog">
            {{ $t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container
      align="center"
      style="
        height: 100%;
        max-height: 100% !important;
        max-width: 100% !important;
        box-sizing: border-box;
        flex-grow: 1;
        overflow: hidden;
      "
      justify="center"
    >
      <l-map
        ref="map"
        :min-zoom="minZoom"
        :max-zoom="maxZoom"
        :zoom="curZoom"
        :crs="crs"
        style="height: 100%; width: 100%; max-height: 100%; z-index: 0"
        @click="handleClick"
        @update:zoom="zoomUpdated"
      >
        <l-image-overlay
          v-if="imageUrl"
          style="z-index: 0"
          ref="iOverlay"
          :url="imageUrl"
          :bounds="bounds"
        />
        <l-marker
          v-for="item in items"
          :key="item.tag.deveui"
          :lat-lng="item.latlng"
          :icon="icon"
        >
          <l-popup
            ><SoContent
              v-on:remove-marker="removeMarker"
              :mode="mode"
              :data="item"
          /></l-popup>
          <l-tooltip :options="{ permanent: true, reactive: true }">
            {{ item.tag.name }}
          </l-tooltip>
        </l-marker>
      </l-map>
    </v-container>
  </v-card>
</template>

<script>
import "leaflet/dist/leaflet.css";
import Enum from "@/_helpers/Enum";
import { mapState, mapActions } from "vuex";
import { CRS, icon } from "leaflet";
import { LMap, LImageOverlay, LMarker, LPopup, LTooltip } from "vue2-leaflet";
import SoContent from "@/components/leaflet/SoContent";

export default {
  name: "ModImageMap",

  components: {
    LMap,
    LImageOverlay,
    LMarker,
    LPopup,
    LTooltip,
    SoContent,
  },

  props: ["module", "mode"],

  data() {
    return {
      addDialog: false,
      deveui: null,
      meta: {
        key: "so_imagemap",
        value: null,
        valueMatch: null,
        content: null,
      },
      loaded: false,
      imgHeight: 0,
      imgWidth: 0,
      imageUrl: null,
      bounds: [
        [0, 0],
        [720, 970],
      ],
      minZoom: -2,
      maxZoom: 3,
      curZoom: null,
      crs: CRS.Simple,
      items: [],
      icon: icon({
        iconUrl:
          "http://icons.iconarchive.com/icons/custom-icon-design/flatastic-6/512/Circle-icon.png",
        iconSize: [15, 15],
        iconAncor: [10, 10],
      }),
    };
  },

  computed: {
    ...mapState("configuration", ["SO_API_BASE_URL"]),
    ...mapState("settings", ["imageMapZoom"]),
    ...mapState("tag", { status: "status", tags: "tags" }),
  },

  methods: {
    ...mapActions("tag", ["getTags", "getTagAsync"]),
    ...mapActions("modules", ["update"]),
    ...mapActions("configuration", ["getBaseUrl"]),
    ...mapActions("settings", ["setImageMapZoom"]),

    zoomUpdated(newZoom) {
      if (newZoom != this.curZoom && newZoom != -1)
        this.setImageMapZoom(newZoom);
    },

    getMeta(url) {
      if (url == undefined || url == "") return;
      return new Promise((resolve, reject) => {
        let img = new Image();
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = url;
      });
    },

    async removeMarker(item) {
      for (let i = 0; i < this.items.length; i++) {
        if (
          this.items[i].latlng.lat == item.latlng.lat &&
          this.items[i].latlng.lng == item.latlng.lng
        ) {
          this.items.splice(i, 1);
          for (let j = 0; j < this.module.meta.length; j++) {
            if (
              this.module.meta[j].value == item.latlng.lat &&
              this.module.meta[j].valueMatch == item.latlng.lng
            ) {
              // eslint-disable-next-line vue/no-mutating-props
              this.module.meta.splice(j, 1);
              await this.update({
                moduleId: this.module.dashboardModuleId,
                payload: this.module,
              });
            }
          }
          break;
        }
      }
    },

    getDefault(item) {
      var val = null;
      var key = null;
      if (item.tag.defaultKey !== undefined) {
        for (let i = 0; i < item.data.length; i++) {
          if (item.data[i].key == item.tag.defaultKey) {
            key = item.data[i].key;
            val = item.data[i].value;
          }
        }
      } else if (item.data[0]) {
        key = item.data[0].key;
        val = item.data[0].value;
      }

      return key + " - " + val;
    },

    async submitDialog() {
      this.meta.content = this.deveui;

      // eslint-disable-next-line vue/no-mutating-props
      this.module.meta.push(this.meta);

      // Update the module
      await this.update({
        moduleId: this.module.dashboardModuleId,
        payload: this.module,
      });

      let tag = await this.getTagAsync(this.deveui);
      let latlng = { lat: this.meta.value, lng: this.meta.valueMatch };
      this.items.push({ tag: tag.tag, data: tag.tagData, latlng: latlng });

      // Reset values
      this.meta = {
        key: "so_imagemap",
        value: null,
        valueMatch: null,
        content: null,
      };

      this.deveui = null;

      // Get tag data and stuff and add them to the array of the inserts
      this.addDialog = false;
    },

    handleClick(event) {
      // Handle the click
      if (this.mode === Enum.DashboardMode.EDIT) {
        this.meta.value = event.latlng.lat;
        this.meta.valueMatch = event.latlng.lng;
        this.addDialog = true;
      }
    },
  },

  async created() {
    await this.getTags();
    this.curZoom = this.imageMapZoom;
    // Loop through attributes and create the object to display tags
    if (this.module.meta == undefined) return;
    for (let i = 0; i < this.module.meta.length; i++) {
      let v = this.module.meta[i];
      let tag = await this.getTagAsync(v.content);
      let latlng = { lat: v.value, lng: v.valueMatch };

      if (Object.keys(tag).length > 0) {
        this.items.push({
          id: v.moduleMetaId,
          tag: tag.tag,
          data: tag.tagData,
          latlng: latlng,
        });
      }
    }
  },

  async mounted() {
    if (this.module.image) {
      await this.getBaseUrl();
      this.imageUrl = `${this.SO_API_BASE_URL}/image/${this.module.image.path}`;

      let ret = await this.getMeta(this.imageUrl);
      this.bounds[1][0] = ret.height;
      this.bounds[1][1] = ret.width;
      // Set zoom parameters
      this.$refs.map.mapObject.options.zoomSnap = 0.05;
      this.$refs.map.mapObject.options.wheelPxPerZoomLevel = 100;
      this.$refs.map.mapObject.options.wheelDebounceTime = 5;

      this.$refs.iOverlay.setBounds(this.bounds);
    } else {
      this.imageUrl = "missing-img.png";
    }
    // Get zoom level appropriate for the displayed image
    let fittingZoom = this.$refs.map.mapObject.getBoundsZoom(this.bounds);

    this.$refs.map.mapObject.setView(
      [this.bounds[1][0] / 2, this.bounds[1][1] / 2],
      fittingZoom
    );
    this.$refs.map.fitBounds(this.bounds);
  },

  watch: {
    imgHeight(val) {
      this.bounds[1][0] = val;
    },

    imgWidth(val) {
      this.bounds[1][1] = val;
    },
  },
};
</script>
